import React from "react";
import { Stack } from "@mui/material";

import { useWorkOrdersContext } from "../../hooks";
import { WorkOrder } from "../../containers";

const WorkOrdersToPrint = () => {
  const { ids } = useWorkOrdersContext();
  return (
    <Stack sx={{ position: "absolute", left: "-9999px" }}>
      {Array.from(ids)?.map((id) => (
        <WorkOrder id={id} baseProps={{ id }} />
      ))}
    </Stack>
  );
};

export default WorkOrdersToPrint;
